export default __webpack_public_path__ + "static/media/Vector.68633f09.svg";